/* eslint-disable react/require-default-props */
import React from 'react';
import Modal from 'react-bootstrap/Modal';

interface HelpVideoModalProps {
  modalVideoOpened: boolean;
  setModalVideoOpened: React.Dispatch<React.SetStateAction<boolean>>;
  urlVideo: string;
  modalTitle?: string;
}

const HelpVideoModal = (props: HelpVideoModalProps) => {
  const { modalVideoOpened, setModalVideoOpened, urlVideo, modalTitle = 'Saiba como usar' } = props;

  return (
    <Modal size="lg" show={modalVideoOpened}>
      <div className="modal-header">
        <h5 className="modal-title text-nowrap">
          <strong>{modalTitle}</strong>
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setModalVideoOpened(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <iframe
          title="monitoramento-video"
          id="video"
          width="100%"
          height="480"
          src={urlVideo}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Modal>
  );
};

export default HelpVideoModal;
